<template>
  <div class="clients">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Kontak</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Kontak</li>
                </ul>
              </div>

              <div class="col-auto float-right ml-auto">
                <a href="#" id="btnAddContact" @click="actShowHideAddContact(true)" class="btn add-btn btn-rounded ml-2" data-toggle="modal" data-target="#add_contact"><i
                    class="fa fa-plus"></i> New Contact</a>
                <div class="dropdown action-label">
                  <a class="btn add-btn btn-rounded dropdown-toggle" href="#" data-toggle="dropdown"
                    aria-expanded="false">
                    <i class="fa fa-plus"></i> Import
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="'/contacts/import-contacts'" class="dropdown-item btn-block">
                    <i class="fa fa-upload"></i> Import contact
                  </router-link>
                  <router-link :to="'/contacts/sync-contacts'" class="dropdown-item btn-block">
                    <i class="fa fa-cloud"></i> Sync
                  </router-link>
                   
                  </div>
                </div>

                <!-- <router-link data-tour-step="2" class="btn add-btn" :to="'/message_report/broadcast/wizard'">
                  <i class="fa fa-bullhorn"></i> Broadcast Baru
                </router-link> -->
                <!-- <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_broadcast"
                >
                  <i class="fa fa-bullhorn"></i> Add
                </a>-->
                <a v-show="false" ref="formBcEdit" class="btn add-btn" @click="showBroadcast(false)" href="#"
                  data-toggle="modal" data-target="#add_broadcast">
                  <i class="fa fa-bullhorn"></i> Edit
                </a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
              <div class="card alert alert-warning">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-6 col-md-4 text-center">
                      <lottie :options="animationsForm1" :width="300" />
                    </div>
                    <div class="col-sm-6 col-md-8 text-wrap">
                      Halo
                      <b>{{ memberSessionArr.name }}</b>,
                      <br />Bingung mau broadcast tapi Leads itu-itu saja?
                      <br />Jangan khawatir, Waajo punya solusinya!!
                      <br />Gunakan fitur <b>Panen Kontak</b> untuk mendapatkan Leads <b
                        class="text text-danger">se-Indonesia</b>...
                      <hr />
                      <div class="text-center" style="margin-top:10px;">
                        <router-link class="btn btn-outline-primary" :to="'/farm-contact/list'"><i
                            class="fa fa-map"></i> Mulai Panen Kontak</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <div class="row " style="margin-bottom:10px;">
            <!-- <div class="col-sm-6 col-md-2">
              <div class="input-group text-right">
                <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">Sync, Import, dll...</button>

                <div class="dropdown-menu">
                  <router-link :to="'/contacts/sync-contacts'" class="dropdown-item btn-block">
                    <i class="fa fa-cloud"></i> Synchronize Whatsapp contacts
                  </router-link>
                  <router-link :to="'/contacts/import-contacts'" class="dropdown-item btn-block">
                    <i class="fa fa-upload"></i> Import contact
                  </router-link>
                  <a href="#" class="dropdown-item btn-block" data-toggle="modal" data-target="#add_group">
                    <i class="fa fa-users"></i> Add a new group
                  </a>
                  <a href="#" id="btnAddContact" class="dropdown-item btn-block add_contact" data-toggle="modal" data-target="#add_contact"
                    @click="actShowHideAddContact">
                    <i class="fa fa-user"></i> Add a new contact
                  </a>

                  <hr />
                  <a href="#" class="dropdown-item btn-block" @click.prevent="removeAllGroup">
                    <i class="fa fa-trash"></i> Remove All group
                  </a>
                  <a href="#" class="dropdown-item btn-block" @click.prevent="unassignFromAllGroup">
                    <i class="fa fa-close"></i> Unassign All contact
                  </a>
                  <a href="#" class="dropdown-item btn-block" @click.prevent="removeAllContact">
                    <i class="fa fa-trash"></i> Remove All contact
                  </a>
                </div>
              </div>
            </div> -->
            <div class="col-sm-6 col-md-2">

              <div class="btn-group">
                <button href="javascript:void(0)" @click="exportData" class="btn btn-outline-secondary">
                  <i class="fa fa-file-excel-o"></i> Export All
                </button>
              </div>
            </div>
          </div>
          <!-- Search Filter -->
          <div class="row filter-row" style="margin-bottom:10px;">
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <multiselect v-model="selectedContact" id="ajax" label="name" track-by="id"
                  :placeholder="'Type to search Group...'" :multiple="true" open-direction="bottom"
                  :custom-label="customLabel" :options="contactOptions" :searchable="true" :loading="isLoading"
                  :internal-search="false" :close-on-select="false" :options-limit="300" :limit="3"
                  :limit-text="limitText" :max-height="600" :show-no-results="true" :hide-selected="true"
                  @search-change="asyncFind" :show-labels="false">
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.name }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <!-- {{ contactOptionsTags }} -->
              <div class="form-group">
                <multiselect-tags v-model="selectedContactTags" id="ajax" label="name" track-by="id"
                  :placeholder="'Type to search Tag...'" :multiple="true" open-direction="bottom"
                  :custom-label="customLabel" :options="contactOptionsTags" :searchable="true"
                  :isLoadingTags="isLoading" :internal-search="false" :close-on-select="false" :options-limit="300"
                  :limit="3" :limit-text="limitText" :max-height="600" :show-no-results="true" :hide-selected="true"
                  @search-change="asyncFindTags" :show-labels="false">
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.name }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="selectedContactTags.length"
                      @mousedown.prevent.stop="clearAllTags(props.search)"></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect-tags>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="form-group form-focus">
                <input v-model="contactListParam.keywords" type="text" class="form-control floating"
                  @change="searchData" />
                <label class="focus-label">Keywords</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-2">
              <a href="javascript:void(0)" @click="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-sm-6 col-md-2 d-flex ">
              <div class="btn-group dropdown-action">
                <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-users"></i> Assign
                  <i class="fa fa-angle-down"></i>
                </button>
                <div class="dropdown-menu">
                  <a :disabled="(selectedCheckbox == 0) ? true : false" class="dropdown-item" href="javascript:void(0)"
                    data-toggle="modal" data-target="#edit_group" @click="actShowHideUpdateGroup">Assign to Group</a>
                  <!-- <a @click.prevent="unassignContactSelected" v-if="contactListParam.group_id.length > 0"
                    :disabled="(selectedCheckbox == 0 || contactListParam.group_id.length == 0) ? true : false"
                    class="dropdown-item" href="javascript:void(0)">Unassign</a> -->
                  <div class="dropdown-divider" v-if="contactListParam.group_id.length > 0"></div>
                  <a class="dropdown-item" @click.prevent="unassignFromOneGroup"
                    v-if="contactListParam.group_id.length > 0">Unassign All</a>
                </div>
              </div>
              <div class="btn-group dropdown-action ml-3">
                <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown">
                  <i class="fa fa-trash"></i> Remove
                  <i class="fa fa-angle-down"></i>
                </button>
                <div class="dropdown-menu">
                  <a @click.prevent="removeOneGroup" v-if="contactListParam.group_id.length > 0" class="dropdown-item"
                    href="javascript:void(0)">Remove Group</a>
                  <a class="dropdown-item" @click.prevent="deleteContactSelected"
                    :disabled="(selectedCheckbox == 0) ? true : false" href="javascript:void(0)"><i class="fa fa-trash"></i> Remove Only Selected [{{selectedCheckbox.length}}] Contact</a>

                    <a href="#" class="dropdown-item text-danger" @click.prevent="removeAllContact">
                    <i class="fa fa-warning"></i><i class="fa fa-trash"></i> Remove All contact
                  </a>
                </div>
              </div>
            </div>
             
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>
                        <div class="btn-group">
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" v-model="selectAllTable" />
                            </label>
                          </div>
                        </div>
                      </th>
                      <th>#</th>
                      <th>Nama</th>
                      <th>No. WA</th>
                      <th>Email</th>
                      <th>Ulang Tahun</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td>
                          <Skeleton :count="1" />
                        </td>
                        <td>
                          <Skeleton :count="1" />
                        </td>
                        <td>
                          <Skeleton :count="1" />
                        </td>
                        <td>
                          <Skeleton :count="1" />
                        </td>
                        <td>
                          <Skeleton :count="1" />
                        </td>
                        <td>
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-wrap">
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" v-model="selectedCheckbox" :value="row" />
                            </label>
                          </div>
                        </td>
                        <td class="text-wrap">
                          <a :disabled="(row.is_group == 1) ? true : false" class="dropdown-item text-primary"
                            href="javascript:void(0)" data-toggle="modal" data-target="#edit_contact"
                            @click="actShowHideUpdate(row.id)"><i class="fa fa-pencil"></i> Edit</a>
                        </td>
                        <td class="text-wrap">
                          {{ row.first_name + " " + row.last_name }}
                        </td>
                        <td class="text-wrap">
                          <template v-if="row.phone_number != 0">
                            <a :href="'https://wa.me/' + row.phone_number" target="_blank"> {{ row.phone_number }}</a>
                          </template>
                          <template v-else>
                            {{ row.phone_number }}
                          </template>
                        </td>
                        <td class="text-wrap">
                          {{ row.email }}
                        </td>
                        <td class="text-wrap">
                          <span v-if="row.birth_date_is_filled == 1"> <i class="fa fa-calendar"></i>
                            {{ formatFromUnixToDate(row.birth_date_data) }}
                          </span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="6" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row" v-if="contactListParam.perPage < totalRecords">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(contactListParam.perPage)" autocomplete="off" name="perPageSelect"
                v-model="contactListParam.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / contactListParam.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' + {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / contactListParam.perPage)
                }">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>

        </div>

        <!-- /edit client -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <create-contact :showAddContact="showAddContact" :filterContactListGroup="filterContactListGroup" v-model="form_data"/>
    <!-- /Add Contact Modal -->

    <!-- Edit Contact Modal -->
    <update-contact v-model="form_data" :filterContactListGroup="filterContactListGroup" :showUpdate="showUpdate" />
    <!-- /Edit Contact Modal -->

    <create-group :getGroupList="getGroupList" />
    <update-group :filterContactListGroup="filterContactListGroup" :showUpdateGroup="showUpdateGroup"
      :selectedCheckbox="selectedCheckbox" />

    <!-- Delete Contact Modal -->
    <div class="modal custom-modal fade" id="delete_contact" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Delete Contact</h3>
              <p>Are you sure want to delete?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a href="javascript:void(0);" class="btn btn-primary continue-btn">Delete</a>
                </div>
                <div class="col-6">
                  <a href="javascript:void(0);" data-dismiss="modal" class="btn btn-primary cancel-btn">Cancel</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import Lottie from "vue-lottie";
import animationReview from "@/assets/lottie/jumping-happy.json";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import CreateContact from "./createContact.vue";
import UpdateContact from "./updateContactV2.vue";
import UpdateGroup from "./updateGroup.vue";
import CreateGroup from "./createGroup.vue";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import MultiselectTags from "vue-multiselect";

import {
  formatFromUnixToDate,
  labelPackageProductEnglish,
  timeAgo,
  convertUTCDatetimeToUnix
} from "@/utils/helper";
import { unix } from "moment";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    MultiselectTags,
    CreateContact,
    UpdateContact,
    UpdateGroup,
    CreateGroup,
    Lottie,

  },
  data() {
    return {
      animationsForm1: { animationData: animationReview, loop: true },

      contactListParam: {
        keywords: '',
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      isLoading: false,
      isLoadingTags: false,
      loading: false,
      selectedContactTags: [],
      contactOptionsTags: [],

      selectedContact: [],
      contactOptions: [],
      contactListParamAuto: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      allContacts: 0,
      showAddContact: "",
      showUpdateGroup: "",
      selectedCheckbox: [],
      parentChecked: false,
      btnActionDisabled: true,
      infiniteId: +new Date(),
      showUpdate: "",
      loadingGroup: false,
      currentState: null,
      loadingMessage: true,
      initScrollTop: 0,
      newData: [],
      currentGroupId: "",
      form_data:{
        id: "",
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: [],
        birth_date_data: '',
        birth_date_is_filled: 0
      },
      currentTagId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 10
      },
      tagListParam: {
        tag_id: null,
        name: "",
        page: 0,
        perPage: 10
      },
    };
    //  isactive : true
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    selectAllTable: {
      get: function () {
        return this.contactListArr
          ? this.selectedCheckbox.length == this.contactListArr.length
          : false;
      },
      set: function (value) {
        var selectedCheckbox = [];

        if (value) {
          this.contactListArr.forEach(function (row) {
            selectedCheckbox.push(row);
          });
        }

        this.selectedCheckbox = selectedCheckbox;
        if (selectedCheckbox.length) {
          this.btnActionDisabled = false;
        } else {
          this.btnActionDisabled = true;
        }
      }
    },
    contactListArr() {
      return this.$store.state.contact.contactListArr;
    },
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },
  async created() {
    // this.getLicenseList();
    const {filter,tag_id,group_id,group_name} = this.$route.query;
    // if(filter && tag_id){
    //   this.selectedContactTags.push({id:tag_id,name:tag_id})
    //   this.contactListParam.tag_id = this.selectedContactTags
    // }
    if(filter && group_id){
      this.selectedContact.push({id:group_id,name:group_name})
      this.contactListParam.group_id = this.selectedContact
    }
    if(filter && tag_id){
      this.selectedContactTags.push({id:tag_id,name:tag_id})
      this.contactListParam.tag_id = this.selectedContactTags
    }
    this.changeContactListArr([]);
    this.asyncFind("");
    this.asyncFindTags("");
    this.loadItems();
    this.currentPage = 1;
   if(tag_id){
    let param = {
      ...this.tagListParam,
      id:tag_id
    }
    this.$store
    .dispatch("contact/getTagList", param).then((res) => {
      if(res.data.data.length > 0){
        this.selectedContactTags = res.data.data
        this.contactListParam.tag_id = this.selectedContactTags
      }
    })
   }
   if(group_id){
    let param = {
      ...this.groupListParam,
      id:group_id
    }
    this.$store
    .dispatch("contact/getGroupList", param).then((res) => {
      if(res.data.data.length > 0){
        this.selectedContact = res.data.data
        this.contactListParam.group_id = this.selectedContact
      }
    })
   }
  },
  filters: {
    labelPackageProductEnglish(value) {
      return labelPackageProductEnglish(value);
    }
  },
  watch: {
    selectedContact: {
      handler: function (val, oldVal) {
        if (val != oldVal) {

          if (val.length > 0) {
            // this.filterContactListTag(val[0].id);
            // this.filterContactListTag(val);
            this.contactListParam.group_id = []
            val.forEach((groupId, idx) => {
              // this.filterContactListTag(val);
              // this.contactListParam.group_id.push(groupId.id);
              // let groupIdArr = {id:groupId}
              // this.contactListParam.group_id.push(groupId);
              this.contactListParam.group_id.push(groupId);
            })
          } else {
            this.contactListParam.group_id = []
            // this.filterContactListTag("");
          }

          // if (val.length > 1) {
          //   let lengthOld = oldVal.length;
          //   val.splice(0, 1);
          //   this.selectedLicense = val;
          // }
          // if (val.length == 1) {
          //   this.filterContactListGroup(val[0].id);
          // } else {
          //   this.filterContactListGroup("");
          // }
        }
      },
      deep: true
    },
    selectedContactTags: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          // if (val.length > 1) {
          //   let lengthOld = oldVal.length;
          //   val.splice(0, 1);
          //   this.selectedLicense = val;
          // }
          if (val.length > 0) {
            // this.filterContactListTag(val[0].id);
            // this.filterContactListTag(val);
            this.contactListParam.tag_id = []
            val.forEach((tagId, idx) => {
              // this.filterContactListTag(val);
              // this.contactListParam.tag_id.push(tagId.id);
              this.contactListParam.tag_id.push(tagId);
            })
          } else {
            this.contactListParam.tag_id = []
            // this.filterContactListTag("");
          }
        }
      },
      deep: true
    }
  },
  methods: {
    formatFromUnixToDate(unixBd) {
      return formatFromUnixToDate(unixBd)
    },
    async searchData() {
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.contactListParam.page =
        this.contactListParam.page - 1 <= 0
          ? await 0
          : await ((this.contactListParam.page - 1) * this.contactListParam.perPage);

      await this.$store
        .dispatch("contact/getContactList", this.contactListParam) // sesuai kan dengan method di API
        .then(response => {
          let data = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;

          if (this.rows.length > 0) {
            this.contactListArr.push(...this.rows);
            this.changeContactListArr(this.contactListArr);
            this.contactListParam.rendered =
              this.contactListParam.page + response.recordsFiltered;
            this.contactListParam.page += response.recordsFiltered;
            if (response.totalRecords > 0) {
              this.contactListParam.totalRecords = response.totalRecords;
            }

            this.loadingMessage = false;
            // this.infiniteHandler(this.currentState, 0, 0);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateParams(newProps) {
      this.contactListParam = Object.assign({}, this.contactListParam, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.contactListParam.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.contactListParam.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.contactListParam.perPage
      });
      await this.loadItems();
    },

    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedCheckbox = [];
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.groupListParam.name = query;
      this.$store
        .dispatch("contact/getGroupList", this.groupListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data;
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    async filterContactListTag(groupId) {
      // if (groupId == "") {
      //   // this.selectedContact = [];
      //   // this.contactOptions = [];
      // }
      // this.currentTagId = groupId;
      // // this.changeContactListArr([]);

      // //   console.log("groupId", groupId);
      // this.tagListParam.totalRecords = 0;
      // this.tagListParam.rendered = 0;
      // this.tagListParam.page = 0;
      // this.tagListParam.perPage = 10;
      this.contactListParam.tag_id = [];
      if (groupId !== "") {
        this.contactListParam.tag_id.push(groupId);
      }
      // this.infiniteId += 1;
      // this.selectedCheckbox = [];

      // this.infiniteHandlerContact();
    },
    asyncFindTags(query) {
      this.isLoadingTags = true;
      this.tagListParam.name = query;
      this.$store
        .dispatch("contact/getTagList", this.tagListParam)
        .then(response => {
          this.isLoadingTags = false;
          var { data } = response.data
          this.contactOptionsTags = data;
          // console.log("response.data: ", data);
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.contactOptionsTags);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingTags = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    clearAllTags() {
      this.selectedContactTags = [];
    },
    removeAllGroup() {
      this.$fire({
        title: "Are you sure you want to remove All Group? ",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          let formDeleteSelected = {
            group_id: ""
          };
          this.$store
            .dispatch("contact/removeGroup", formDeleteSelected)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(r => {
                this.getGroupList();
                this.contactListParam.group_id = [];
                this.filterContactListByName();
                this.currentGroupId = "";
              });
            });
        }
      });
      this.selectedCheckbox = [];
    },
    removeOneGroup() {
      if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select group to remove",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title: "Are you sure you want to remove this group? ",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              group_id: this.contactListParam.group_id[0]
            };
            this.$store
              .dispatch("contact/removeGroup", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.getGroupList();
                  this.contactListParam.group_id = [];
                  this.filterContactListByName();
                  this.currentGroupId = "";
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    exportData() {
      let newParam = this.contactListParam;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 0; //unlimited
      this.$store.dispatch("contact/exportData", newParam).then(response => {
        this.$fire({
          title: "Preparing",
          text: response["msg"],
          type: "warning",
          timer: 3000
        });
      });
    },
    unassignFromAllGroup() {
      this.$fire({
        title:
          "Are you sure you want to unassign all contacts from all group? ",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          let formDeleteSelected = {
            group_id: ""
          };
          this.$store
            .dispatch("contact/unassignGroup", formDeleteSelected)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(r => {
                this.contactListParam.group_id = [];
                this.filterContactListByName();
                this.getGroupList();
                this.selectedCheckbox = [];
              });
            });
        }
      });
    },
    unassignFromOneGroup() {
      if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select group to unassign",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title:
            "Are you sure you want to unassign all contacts from this group? ",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              group_id: this.contactListParam.group_id[0]
            };
            this.$store
              .dispatch("contact/unassignGroup", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.filterContactListGroup(
                    this.contactListParam.group_id[0]
                  );
                  this.getGroupList();
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    unassignContactSelected() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Warning",
          text: "Please select one or more contacts to unassign",
          type: "warning",
          timer: 3000
        });
        return;
      } else if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Warning",
          text: "Please select group to unassign",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title:
            "Are you sure you want to unassign some contacts from this group? ",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              id: this.selectedCheckbox,
              group_id: this.contactListParam.group_id[0]
            };
            // console.log("formDeleteSelected",formDeleteSelected)
            this.$store
              .dispatch("contact/unassignContactSelected", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.filterContactListGroup(
                    this.contactListParam.group_id[0]
                  );
                  this.getGroupList();
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    deleteContactSelected() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Warning",
          text: "Please select one or more contacts to delete",
          type: "warning",
          timer: 3000
        });
        return;
      } else {
        this.$fire({
          title:
            "Are you sure you want to delete some contacts? This action cannot be rolled back.",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `Cancel`
        }).then(async r => {
          if (r.value == true) {
            let formDeleteSelected = {
              id: this.selectedCheckbox
            };
            this.$store
              .dispatch("contact/deleteContactSelected", formDeleteSelected)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: response["msg"],
                  type: "success",
                  timer: 3000
                }).then(r => {
                  this.filterContactListByName();
                  this.selectedCheckbox = [];
                });
              });
          }
        });
      }
    },
    removeAllContact() {
      this.$fire({
        title:
          "Are you sure you want to remove all contacts? This action cannot be rolled back.",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          this.$store.dispatch("contact/removeAllContact").then(response => {
            this.$fire({
              title: "Success",
              text: response["msg"],
              type: "success",
              timer: 3000
            }).then(r => {
              this.filterContactListByName();
            });
          });
        }
      });
    },
    checkChild: function (idx, $event) {
      // console.log("idx", idx);
      // console.log("$event", $event.target.checked);
      if ($event.target.checked == true) {
        this.selectedCheckbox.push(idx);
        this.btnActionDisabled = false;

        // this.$store.dispatch("bonus/selectedWD", this.selectedWD);
      } else {
        if (this.selectedCheckbox.length > 0) {
          let index = this.selectedCheckbox.indexOf(idx);
          if (index > -1) {
            // only splice array when item is found
            this.selectedCheckbox.splice(index, 1); // 2nd parameter means remove one item only
          }
        } else {
          this.btnActionDisabled = true;
        }
      }
    },
    actShowHideAddContact() {
      this.showAddContact = "1";
      this.form_data = {
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: [],
        birth_date_data: "",
        birth_date_is_filled_checkbox: false,
        birth_date_is_filled: 0,
      }
    },
    actShowHideUpdateGroup() {
      this.showUpdateGroup = "1";
    },
    async actShowHideUpdate(value) {
      this.showUpdate = value;
      await this.$store.dispatch("contact/viewContact", value).then(response => {
        var { contact_list, contact_rel } = response; 
        this.form_data = {
          id: contact_list.id,
          email: contact_list.email,
          phone_number: contact_list.phone_number,
          first_name: contact_list.first_name,
          last_name: contact_list.last_name,
          list_id: contact_rel,
          birth_date_data: this.$moment.unix(contact_list.birth_date_data).format("YYYY-MM-DD"),
          birth_date_is_filled: contact_list.birth_date_is_filled == 1 ? true : false,
          // birth_date_is_filled_checkbox: contact_list.birth_date_is_filled == 1 ? true : false, 
        }
       
      });
    },
    
    async filterContactListByName() {
      this.changeContactListArr([]);

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 20;
      this.contactListParam.group_id = [];
      // this.infiniteId += 1;
      this.selectedCheckbox = [];
      this.searchData()

      // this.infiniteHandlerContact();
    },
    async filterContactListGroup(groupId) {
      if (groupId == "") {
        // this.selectedContact = [];
        // this.contactOptions = [];
      }
      this.currentGroupId = groupId;
      this.changeContactListArr([]);

      //   console.log("groupId", groupId);
      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 10;
      this.contactListParam.group_id = [];
      if (groupId !== "") {
        let arrGroupId = { id: groupId };
        // this.contactListParam.group_id.push(groupId);
        this.contactListParam.group_id.push(arrGroupId);
      }
      // this.infiniteId += 1;
      this.selectedCheckbox = [];

      // this.infiniteHandlerContact();
    },
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
        .catch(error => {
          //   this.loading = false;
          this.loadingGroup = false;

          console.log("error", error);
        });
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    async changeContactListArr(data) {
      //   console.log("panrtnenemee", data);
      //   console.log("contactListArrxxx::", this.contactListArr);
      var newArr = await this.getUniqueListBy(data, "id");
      //   console.log("newArr", newArr);

      // console.log("builllll", buildArr);
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      await this.$store.dispatch("contact/setContactListArr", newArr);
    },
  },
  beforeDestroy() {
    this.$root.$off("getGroupList");

  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
    const {act} = this.$route.query;
    if (act == "add") { 
      setTimeout(() => {    
        document.getElementById("btnAddContact").click(); // Click on the checkbox
      }, 500);
    }
  },
  name: "licenseList"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/listV2.vue